import { useDispatch } from 'react-redux';
import { useKeyboard } from '../../../shared/hooks/useKeyboard';
import { useWindowListener } from '../../../shared/hooks/useWindowListener';
import { stopNavigation } from '../../navigation/thunks/stop-navigation.thunk';
import { toggleRuler } from '../../ruler/thunks/toggle-ruler.thunk';
import { stopRuler } from '../../ruler/thunks/stop-ruler.thunk';
import { stopRuler2d } from '../../ruler2d/thunks/stop-ruler2d.thunk';
import { deleteSelectedWaves } from '../../wave/thunks/delete-selected-waves.thunk';
import { setWaveDepth } from '../../wave/thunks/set-wave-depth.thunk';
import { unselectAllWaves } from '../../wave/thunks/unselect-all-waves.thunk';
import { updateWave } from '../../wave/thunks/update-wave.thunk';
import { setActiveTool } from '../../tool/actions/tool.actions';
import { stopEpisodeMeasurement } from '../../episodeMeasurement/thunks/stop-measurement.thunk';
import { initializeRuler } from '../../ruler/thunks/initialize-ruler.thunk';
import { checkToSendUseToolEvent } from '../thunks/check-to-send-use-ruler-event.thunk';

export const useCoreListener = (plotId: string) => {
  const dispatch = useDispatch();

  /*
   * Background listeners
   * Use up and down arrows to move the selected waves along the z-axis
   */
  useKeyboard('keydown', 'ArrowUp', () => {
    dispatch(setWaveDepth('up'));
  });

  useKeyboard('keydown', 'ArrowDown', () => {
    dispatch(setWaveDepth('down'));
  });

  /*
   * Unselect listener
   * When the user presses Escape or clicks outside the plot, it un-selects the wave
   */
  useKeyboard('keydown', 'Escape', () => {
    dispatch(checkToSendUseToolEvent());
    dispatch(
      setActiveTool({
        tool: null,
        meta: { history: false },
      }),
    );
    dispatch(unselectAllWaves());
  });

  useWindowListener('click', (event) => {
    const container = document.getElementById(plotId);
    if (
      event.target instanceof Node &&
      container instanceof Node &&
      !container.contains(event.target)
    ) {
      dispatch(unselectAllWaves());
    }
  });

  /*
   * Update listener
   * When the user releases the mouse, we update the current wave
   */
  useWindowListener('mouseup', () => {
    dispatch(updateWave());
  });

  /*
   * Delete listener
   * When the user hits Delete/Backspace
   */
  useKeyboard(
    'keydown',
    'Backspace',
    (event) => {
      if (dispatch(deleteSelectedWaves())) {
        event.preventDefault();
      }
    },
    { throttle: false }, // we can't throttle or Firefox will go back to the previous page before we use preventDefault
  );

  /**
   * Activate / deactivate ruler
   */
  useKeyboard('keydown', 'm', () => {
    dispatch(toggleRuler());
    dispatch(initializeRuler());
  });

  useKeyboard('keydown', 'Delete', (event) => {
    if (dispatch(deleteSelectedWaves())) {
      event.preventDefault();
    }
  });

  /*
   * Ruler listener
   * When the user releases the mouse, we stop updating the ruler's position
   */
  useWindowListener('mouseup', () => {
    dispatch(stopRuler());
    dispatch(stopRuler2d());
    dispatch(stopEpisodeMeasurement());
  });

  /*
   * Navigation listener
   * When the user releases the mouse, we stop updating the ruler's position
   */
  useWindowListener('mouseup', () => {
    dispatch(stopNavigation());
  });
};
